"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import type { ReactNode } from "react";
import Navbar from "@/components/Navbar";
import PostHeader from "@/components/posts/PostHeader";
import { useLanguage } from "@/contexts/LanguageContext";
import type { PostMeta } from "@/lib/posts";
interface PostLayoutProps {
  post: PostMeta;
  children: ReactNode;
}
export default function PostLayout(t0) {
  const $ = _c(14);
  const {
    post,
    children
  } = t0;
  const {
    t
  } = useLanguage();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Navbar />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== post) {
    t2 = <PostHeader post={post} />;
    $[1] = post;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children) {
    t3 = <article className="prose dark:prose-invert max-w-none">{children}</article>;
    $[3] = children;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><title>Back arrow</title><path strokeLinecap="round" strokeLinejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" /></svg>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t("posts.backToList");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <div className="mt-12 border-t border-border-default pt-6"><Link href="/posts/" className="inline-flex items-center gap-2 text-sm font-medium text-brand-primary hover:underline">{t4}{t5}</Link></div>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t2 || $[11] !== t3 || $[12] !== t6) {
    t7 = <div className="bg-surface min-h-screen">{t1}<main className="mx-auto max-w-3xl px-6 py-12">{t2}{t3}{t6}</main></div>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}